module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 9.ca2fd37e.png";